if (!customElements.get('cart-upsell-form')) {
  customElements.define(
    'cart-upsell-form',
    class CartUpsellForm extends HTMLElement {
      constructor() {
        super();

        if (this.querySelector('form') != null) {
          this.form = this.querySelector('form');
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.submitButton = this.querySelector('[type="submit"]');
          if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              console.log('quickAddModal hide');
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

// CROSS SELL VARIANTS

function cartOpenVariantPopUp(id) {
  var variantPopUp = document.querySelector(`.cart-dc-product-variant-popup-${id}`);
  variantPopUp.classList.add('cart-open');
  initVariantSwatches(variantPopUp);
}
function cartCloseVariantPopUp(elemClass) {
  var elem = document.querySelector(elemClass);
  setTimeout(() => {
    elem.classList.remove('cart-open');
  }, '300');
}

function initVariantSwatches(popup) {
  const allSwatches = popup.querySelectorAll('.variant-swatch-label');
  const variantsBundleWrapper = popup.querySelector('.variants-bundle-wrapper');
  const productFormSubmit = popup.querySelector('.product-form__submit');
  const propertiesContainer = popup.querySelector('.variants-selected-properties__container');
  const tooltips = popup.querySelectorAll('.tooltip');
  const alertText = popup.querySelector('#alert-text-container');
  const limit = parseInt(variantsBundleWrapper.dataset.limit, 10);

  let limitCount = 0;

  function handleSubmitState() {
    if (limitCount !== limit) return false;
    return true;
  }

  productFormSubmit.addEventListener('click', (e) => {
    if (!handleSubmitState()) {
      e.preventDefault();
      if (alertText != null) {
        alert(alertText.innerText);
      } else {
        alert('ATTENTION VOUS DEVEZ CHOISIR VOS COULEURS');
      }
    } else {
      e.preventDefault();
      addPropertiesToForm();
      popup.querySelector('product-form').onSubmitHandler(e);
    }
  });

  function rgbToHex(rgb) {
    // Sépare les valeurs R, G et B de la chaîne RGB
    var regex = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/;
    var match = regex.exec(rgb);
    var r = parseInt(match[1]);
    var g = parseInt(match[2]);
    var b = parseInt(match[3]);

    // Convertit les valeurs R, G et B en hexadécimal
    var hex = '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);

    // Renvoie la valeur hexadécimale
    return hex;
  }

  function isLight(color) {
    const hex = color.replace('#', '');
    const c_r = parseInt(hex.substring(0, 0 + 2), 16);
    const c_g = parseInt(hex.substring(2, 2 + 2), 16);
    const c_b = parseInt(hex.substring(4, 4 + 2), 16);
    const brightness = (c_r * 299 + c_g * 587 + c_b * 114) / 1000;
    return brightness > 155;
  }

  // Change text color if background is too light
  for (let i = 0; i < tooltips.length; i++) {
    let tooltip = tooltips[i];
    let color = tooltip.style.background;
    if (color != '') {
      color = rgbToHex(color);
      if (isLight(color)) {
        tooltip.style.color = '#000';
      }
    }
  }

  // Tooltip function that follow the mouse pointer on hover
  function followPointer(event, swatch) {
    var x = event.clientX,
      y = event.clientY;
    swatch.querySelector('.tooltip').style.top = y + 5 + 'px';
    swatch.querySelector('.tooltip').style.left = x + 10 + 'px';
  }

  allSwatches.forEach((swatch) => {
    swatch.addEventListener('click', function () {
      selectColor(swatch);
    });
    swatch.addEventListener('mousemove', function (event) {
      followPointer(event, swatch);
    });
  });

  function selectColor(swatch) {
    var qtyLabel = swatch.querySelector('.product-selected-number');
    if (swatch.dataset.method == 'increment') {
      swatch.dataset.quantity++;
      limitCount++;
    } else {
      swatch.dataset.quantity--;
      limitCount--;
      if (swatch.dataset.quantity == 0) swatch.dataset.method = 'increment';
    }

    updateQuantityLabel(swatch, qtyLabel);
    updateSwatchState(swatch, qtyLabel);

    const nearLimit = limit - 1;

    switch (limitCount) {
      case limit:
        popup.querySelectorAll('.variant-swatch.active').forEach((swatch) => {
          swatch.dataset.method = 'decrement';
        });
        popup.querySelectorAll('.variant-swatch:not(.active)').forEach((swatch) => {
          swatch.classList.add('variant-swatch-label-disabled');
        });
        break;
      case 0:
        popup.querySelectorAll('.variant-swatch').forEach((swatch) => {
          swatch.dataset.method = 'increment';
        });
        popup.querySelectorAll('.variant-swatch:not(.active)').forEach((swatch) => {
          swatch.classList.remove('variant-swatch-label-disabled');
        });
        break;

      default:
        popup.querySelectorAll('.variant-swatch:not(.active)').forEach((swatch) => {
          swatch.classList.remove('variant-swatch-label-disabled');
        });
        break;
    }

    if (limitCount === limit) {
      let selectedColors = [];
      popup.querySelectorAll('.variant-swatch.active').forEach((swatch) => {
        for (let i = 0; i < swatch.dataset.quantity; i++) {
          selectedColors.push(swatch.dataset.name);
        }
      });
      let selectedColorsString = selectedColors.join(' x ');
      popup.querySelector('.variant-bundle__legend-container legend').innerText = '🎉 Sélection : ' + selectedColorsString;
    } else if (limitCount === nearLimit) {
      popup.querySelector('.variant-bundle__legend-container legend').innerText = "Plus qu'une couleur à choisir :";
    } else {
      popup.querySelector('.variant-bundle__legend-container legend').innerText = 'Choisissez vos couleurs :';
    }
  }

  function updateQuantityLabel(swatch, qtyLabel) {
    qtyLabel.innerHTML = swatch.dataset.quantity;
    qtyLabel.style.visibility = 'visible';
    if (parseInt(qtyLabel.innerHTML) === 0) qtyLabel.style.visibility = 'hidden';
  }

  function updateSwatchState(swatch, qtyLabel) {
    swatch.classList.add('active');
    if (parseInt(qtyLabel.innerHTML) === 0) swatch.classList.remove('active');
  }

  function addPropertiesToForm() {
    var index = 1;
    popup.querySelectorAll('.variant-swatch.active').forEach((swatch) => {
      for (let i = 0; i < swatch.dataset.quantity; i++) {
        propertiesContainer.innerHTML += '<input type="hidden" name="properties[Couleur ' + index + ']" value="' + swatch.dataset.name + '">';
        propertiesContainer.innerHTML += '<input type="hidden" name="properties[COLOR-SKU ' + index + ']" value="' + swatch.dataset.sku + '">';
        index++;
      }
    });
  }
}
